import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Loan } from 'src/model/loan.model';
import { User } from 'src/model/user.model';
import { UserService } from 'src/services/user.service';

@Component({
    selector: 'app-add-commissions',
    templateUrl: './add-commissions.component.html',
    styleUrls: ['./add-commissions.component.scss'],
    standalone: false
})
export class AddCommissionsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private userService = inject(UserService);

  @Input() companyAccountList: Account[] = [];

  selectedAccountId: number;
  selectedUser: string;
  loggedInCompanyId: number;

  @Input() selectedLoan: Loan;
  @Output() passEntry = new EventEmitter<any>();
  //2-WAY BINDING INFO
  date: Date;
  remark: string;
  staffAmount = 0;
  otherAmount = 0;
  userList: User[] = [];

  disabledSubmit = false;

  constructor() {
    this.date = new Date();
  }

  ngOnInit(): void {
    this.loggedInCompanyId = Number(sessionStorage.getItem("companyId"));

    this.getAllUsersOfCompany();
    this.getAllAccountsOfCompany(this.loggedInCompanyId);
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          const loggedInUsername = sessionStorage.getItem("username");
          if (json.username == loggedInUsername || json.username == undefined)
            this.companyAccountList.push(account);
        });
      }
    };
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  setSelectedUser(username: string) {
    if (username === this.selectedUser)
      return true
    else
      return false;
  }

  private async getAllUsersOfCompany() {
    this.userList = await this.userService.getAllUsers({ isActive: true });
  }

  isBalanceInsufficient(balance: number) {
    if (balance > this.staffAmount + this.otherAmount)
      return false;
    else
      return true;
  }

  isFieldNull() {
    const staffPaymentNull = (this.staffAmount == undefined || this.staffAmount == 0);
    if (this.otherAmount != 0 && this.otherAmount != undefined) {
      var remarkNull = (this.remark == undefined || this.remark == "");
      var selectedAccountIdNull = (this.selectedAccountId == undefined)
    }
    else {
      var remarkNull = false;
      var selectedAccountIdNull = false;
    }
    const selectedUserNull = (this.selectedUser == undefined);
    const paymentValid = isNaN(+this.staffAmount)

    if (staffPaymentNull == true && this.otherAmount != 0 && this.otherAmount != undefined)
      return remarkNull || selectedAccountIdNull || paymentValid;
    else
      return remarkNull || selectedAccountIdNull || selectedUserNull || staffPaymentNull || paymentValid;
  }

  confirmBeforeAddCommission() {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);

    if (this.otherAmount == 0 || this.otherAmount == undefined)
      modalRef.componentInstance.message = "You are going to assign RM " + this.staffAmount + " to " + this.selectedUser + "\n.Are you sure?";
    else {
      if (this.staffAmount != 0 && this.staffAmount != undefined)
        modalRef.componentInstance.message = "You are going to assign RM " + this.staffAmount + " to " + this.selectedUser + " and RM " + this.otherAmount + " as " + this.remark + ". \nAre you sure?";
      else
        modalRef.componentInstance.message = "You are going to assign RM " + this.otherAmount + " as " + this.remark + ". \nAre you sure?";
    }

    modalRef.result.then((confirm) => {
      if (confirm) {
        if (this.staffAmount > 0 && this.staffAmount != undefined)
          this.addStaffCommission();
        else
          this.addOtherCommission();
      }
    });

    return proceed;
  }

  addOtherCommission() {
    const isoTaskDate = (new Date(Number(this.date))).toISOString();

    const data = {
      "amount": this.otherAmount,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddCompanyExpenseByExtras(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        // var json = JSON.parse(xhr.responseText);

        if (xhr.status == 200) {
          const account = new Account(this.selectedAccountId, null, null, null, null, null, null, -this.otherAmount)
          // this.passEntry.emit(account)
          window.location.reload();

          this.reset();
          this.sharedService.openAlert("Successfully added commission by using duit lebih", ALERT_TYPE.SUCCESS);
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  confirmBeforeLeaving() {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You are going to leave without assigning any commission, are you sure?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.reset();
    });

    return proceed;
  }

  addStaffCommission() {
    this.disabledSubmit = true;

    const isoTaskDate = (new Date(Number(this.date))).toISOString();

    const data = {
      "amount": this.staffAmount,
      "dateCreated": isoTaskDate,
      "assignee": this.selectedUser
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAssignLoanCommission(this.selectedLoan.ID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          //after assigning staff commission, add other commission

          if (this.otherAmount > 0)
            this.addOtherCommission();
          else {
            window.location.reload();
            this.reset();
          }

          this.sharedService.openAlert("Successfully added commission!", ALERT_TYPE.SUCCESS);
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  submit() {
    (this.isFieldNull()) ? this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER) : this.confirmBeforeAddCommission();
  }

  reset() {
    this.activeModal.close();
    window.location.reload();
  }
}
